<template>
    <div class="one-among-area two-among-area pt-100 pb-70" id="service">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">{{ $t('services.why.title') }}</span>
                <h3>{{ $t('services.why.heading') }}</h3>
                <p>{{ $t('services.why.desc') }}</p>
            </div>

            <div class="row">

                <div class="col-sm-6 col-lg-4">
                    <div class="among-item">
                        <div class="among-top">
                            <img src="../../assets/img/resources/container1.png" alt="Among">
                            <div class="among-icon">
                                <i class='bx bx-layout'></i>
                            </div>
                        </div>
                        <div class="among-bottom">
                            <h3>{{ $t('services.card1.title') }}</h3>
                            <p>{{ $t('services.card1.desc') }}</p>
                            <a href="https://wa.me/34634061655" target="_blank">
                                {{ $t('services.cta') }}
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="among-item">
                        <div class="among-top">
                            <img src="../../assets/img/resources/container2.png" alt="Among">
                            <div class="among-icon">
                                <i class='bx bx-globe'></i>
                            </div>
                        </div>
                        <div class="among-bottom">
                            <h3>{{ $t('services.card2.title') }}</h3>
                            <p>{{ $t('services.card2.desc') }}</p>
                            <a href="https://wa.me/34634061655" target="_blank">
                                {{ $t('services.cta') }}
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="among-item">
                        <div class="among-top">
                            <img src="../../assets/img/resources/container3.png" alt="Among">
                            <div class="among-icon">
                                <i class='bx bx-chat'></i>
                            </div>
                        </div>
                        <div class="among-bottom">
                            <h3>{{ $t('services.card3.title') }}</h3>
                            <p>{{ $t('services.card3.desc') }}</p>
                            <a href="https://wa.me/34634061655" target="_blank">
                                {{ $t('services.cta') }}
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>